import React from 'react';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';

const BodySkeletonList = React.memo(styled(({ className, ...props }) =>
  [...new Array(10).keys()].map((i) => (
    <Skeleton key={i} {...props} className={className} />
  )),
)`
  ${({ theme }) => `
    width: 100%;
    height: calc(${theme.typography.pxToRem(16)} * ${
    theme.typography.body1.lineHeight
  } * (1 / .6));
  `}
`);

export default BodySkeletonList;
